var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("a", {
        staticClass: "btn-back",
        attrs: { href: "javascript:history.go(-1)" },
      }),
      _vm._v(" "),
      _c("h2", [_vm._v("热搜词")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }